// Keep Playing uses the site's existing Fathom script. No customer identifiers
// leave this module; purchase deduplication belongs to the server's paid record.
var root = null;
var exposure = new Set();
var pending = new Map();
var observer = null;
var claiming = false;
var claimAgain = false;

const names = new Set([
    'Shown', 'Opened', 'Apple Pay Available', 'Google Pay Available', 'Link Available',
    'Card Opened', 'Payment Options Failed', 'Payment Started', 'Payment Failed', 'Purchased'
]);

function trackerReady() {
    try {
        return !!(window.fathom && typeof window.fathom.trackEvent === 'function'
            && (!window.fathom.isTrackingEnabled || window.fathom.isTrackingEnabled()));
    } catch (error) { return false; }
}

function flush() {
    if (!trackerReady()) return;
    pending.forEach(function (count, name) {
        pending.delete(name);
        for (var i = 0; i < count; i += 1) {
            try { window.fathom.trackEvent('Keep Playing ' + name); }
            catch (error) { /* Analytics must never interrupt listening or payment. */ }
        }
    });
}

export function trackKeepPlaying(name, once = true) {
    if (!names.has(name) || name === 'Purchased' || !root || !root.isConnected) return;
    if (once && exposure.has(name)) return;
    if (once) exposure.add(name);
    pending.set(name, (pending.get(name) || 0) + 1);
    flush();
}

function shown() {
    if (!root || !root.isConnected || document.hidden) return;
    var trigger = root.querySelector('[data-jukebox-open]');
    var rect = trigger.getBoundingClientRect();
    var style = getComputedStyle(trigger);
    if (rect.width && rect.height && rect.bottom > 0 && rect.top < window.innerHeight
        && rect.right > 0 && rect.left < window.innerWidth
        && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0) {
        trackKeepPlaying('Shown');
    }
}

export function observeKeepPlaying(candidate) {
    if (observer) observer.disconnect();
    root = candidate;
    if (!root) {
        exposure.clear();
        pending.clear();
        claimAgain = false;
        return;
    }
    // Replacing rows or this root during a continuous Music visit retains the
    // exposure flags. Leaving Music, or a new document, starts a new exposure.
    if (window.IntersectionObserver) {
        observer = new IntersectionObserver(shown);
        observer.observe(root.querySelector('[data-jukebox-open]'));
    }
    shown();
}

export function trackVerifiedKeepPlaying(state) {
    // An existing active hour is not proof that a second checkout succeeded.
    // The server independently selects and atomically claims only paid records.
    claimAgain = state.active === true && state.purchase_pending === true;
    claimPurchase();
}

function claimPurchase() {
    if (!claimAgain || claiming || !root || !root.isConnected || !trackerReady()) return;
    var target = root;
    claiming = true;
    claimAgain = false;
    fetch(target.dataset.conversionUrl, {
        method: 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json', 'X-CSRF-TOKEN': target.dataset.csrf }
    }).then(function (response) {
        if (!response.ok) return;
        return response.json();
    }).then(function (result) {
        if (result && result.purchased === true && trackerReady()) {
            // Fathom's _value is cents, not dollars. Set this event's currency
            // to USD in Fathom; do not change the site's currency default.
            window.fathom.trackEvent('Keep Playing Purchased', { _value: 100 });
        }
    }).catch(function () {
        // No retry of a consumed claim: Fathom has no receipt/idempotency API.
        // Failed transport may undercount, but must never double count a sale.
    }).finally(function () { claiming = false; });
}

// A deferred/blocked analytics script must never hold up the product. Retry only
// unsent exposure events and an unclaimed conversion when the existing script loads.
window.addEventListener('load', function () { shown(); flush(); claimPurchase(); });
document.addEventListener('load', function (event) {
    if (event.target.tagName === 'SCRIPT' && event.target.hasAttribute('data-site')) {
        shown(); flush(); claimPurchase();
    }
}, true);
document.addEventListener('visibilitychange', function () {
    if (!document.hidden) { shown(); flush(); claimPurchase(); }
});
